import { RouteParam } from "../../../../routes";
import { ACTION, MODULE } from "../../../../utils/enums";
import { urls } from "../../../../utils/urls";
import PaymentRequestAdvanceApprovalScreen from "../payment_request_approval_view/advance_payment_request_approval_view";
import PaymentRequestInvoiceApprovalScreen from "../payment_request_approval_view/invoice_payment_request_approval_view";
import PaymentRequestApprovalListForAdvanceAndInvoice from "../pre_payment_req_approval_list";
import PaymentRequestListForAdvanceAndInvoice from "../pre_payment_req_list";
import PaymentRequestAdvanceScreen from "../prev_payment_request_view/advance_payment_request_view";
import PaymentRequestInvoiceScreen from "../prev_payment_request_view/invoice_payment_request_view";


const prev_payment_request_routes: RouteParam[] = [
  {
    isPrivate: true,
    fullScreen: false,
    exact: true,
    path: urls.po_advance_payment_request_prev,
    component: PaymentRequestListForAdvanceAndInvoice,
    module: MODULE.payment_request_maker,
    main_module: MODULE.procurement_panel,
    action: [ACTION.CREATE, ACTION.READ, ACTION.UPDATE],
    operator: "or",
  },
  {
    isPrivate: true,
    fullScreen: false,
    exact: true,
    path: urls.po_payment_request_approval_prev,
    component: PaymentRequestApprovalListForAdvanceAndInvoice,
    module: MODULE.payment_request_checker,
    main_module: MODULE.procurement_panel,
    action: [ACTION.CREATE, ACTION.READ, ACTION.UPDATE],
    operator: "or",
  },
  {
    isPrivate: true,
    fullScreen: false,
    exact: true,
    path: urls.po_advance_payment_request_prev + "/updateAdvance/:id",
    component: PaymentRequestAdvanceScreen,
    module: MODULE.payment_request_maker,
    main_module: MODULE.procurement_panel,
    action: [ACTION.CREATE, ACTION.READ, ACTION.UPDATE],
    operator: "or",
  },
  {
    isPrivate: true,
    fullScreen: false,
    exact: true,
    path: urls.po_advance_payment_request_prev + "/updateInvoice/:id",
    component: PaymentRequestInvoiceScreen,
    module: MODULE.payment_request_maker,
    main_module: MODULE.procurement_panel,
    action: [ACTION.CREATE, ACTION.READ, ACTION.UPDATE],
    operator: "or",
  },
  {
    isPrivate: true,
    fullScreen: false,
    exact: true,
    path: urls.po_payment_request_approval_prev + "/approveAdvance/:id",
    component: PaymentRequestAdvanceApprovalScreen,
    module: MODULE.payment_request_checker,
    main_module: MODULE.procurement_panel,
    action: [ACTION.CREATE, ACTION.READ, ACTION.UPDATE],
    operator: "or",
  },
  {
    isPrivate: true,
    fullScreen: false,
    exact: true,
    path: urls.po_payment_request_approval_prev + "/approveInvoice/:id",
    component: PaymentRequestInvoiceApprovalScreen,
    module: MODULE.payment_request_checker,
    main_module: MODULE.procurement_panel,
    action: [ACTION.CREATE, ACTION.READ, ACTION.UPDATE],
    operator: "or",
  },
];

export default prev_payment_request_routes;